@if (!mapOnly()) {
  @if (showLanguageSelector) {
    <assist-dropdownlist
      [data]="languageItems"
      [formControl]="currentLanguageControl"
      cueRtl
      [popupSettings]="{
        popupClass: 'language-popup',
        width: 'auto',
      }"
      class="language-dropdown"
      textField="text"
      valueField="text"
      [listHeight]="400"
      data-cy="select-language"
    >
      <ng-template let-dataItem valueTemplate>
        <img [src]="'assets/images/flags/' + dataItem?.flag" class="flag" height="30" width="30" />
      </ng-template>
      <ng-template itemTemplate let-dataItem>
        <img [src]="'assets/images/flags/' + dataItem.flag" class="flag" height="30" width="30" />
        <span class="lang-shortcut">{{ dataItem.text }}</span>
      </ng-template>
    </assist-dropdownlist>
  }
  <div class="orientation-notice">{{ 'navigation.orientationNotice' | transloco }}</div>
}
<router-outlet></router-outlet>
